export default __webpack_public_path__ + "static/media/blog-img-35.6a034054.jpg";